import { render, staticRenderFns } from "./ReturnFromBill.vue?vue&type=template&id=0c01834a&scoped=true"
import script from "./ReturnFromBill.vue?vue&type=script&lang=js"
export * from "./ReturnFromBill.vue?vue&type=script&lang=js"
import style0 from "./ReturnFromBill.vue?vue&type=style&index=0&id=0c01834a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01834a",
  null
  
)

export default component.exports